import api from './api';
import { HealthProfile } from '../types';

export const profileService = {
  /**
   * Get user's health profile (including profileType from user profile)
   */
  async getProfile(): Promise<HealthProfile> {
    try {
      // Fetch health profile
      const healthProfileResponse = await api.get<HealthProfile>('/profile');
      const healthProfile = healthProfileResponse.data;
      
      console.log('[ProfileService] Health profile response:', healthProfile);
      console.log('[ProfileService] termsAcceptedAt:', healthProfile?.termsAcceptedAt);
      
      // Fetch user profile to get profileType
      try {
        const userProfileResponse = await api.get<any>('/user/profile');
        const userProfile = userProfileResponse.data;
        
        console.log('User profile data:', userProfile);
        console.log('Profile type from backend:', userProfile?.profileType);
        
        // Merge profileType from user profile
        const mergedProfile = {
          ...healthProfile,
          profileType: userProfile?.profileType,
        };
        
        console.log('Merged profile with profileType:', mergedProfile.profileType);
        return mergedProfile;
      } catch (err) {
        // If user profile fetch fails, return health profile as is
        console.warn('Could not fetch user profile for profileType:', err);
        return healthProfile;
      }
    } catch (error) {
      throw error;
    }
  },

  /**
   * Save/update user's health profile
   */
  async saveProfile(profile: HealthProfile): Promise<{ status: string }> {
    const response = await api.post<{ status: string }>('/profile', profile);
    return response.data;
  },

  /**
   * Accept Terms & Conditions
   */
  async acceptTerms(): Promise<{ status: string; termsAcceptedAt: string }> {
    console.log('[ProfileService] Calling accept-terms endpoint...');
    const response = await api.post<{ status: string; termsAcceptedAt: string }>('/profile/accept-terms');
    console.log('[ProfileService] Accept terms response:', response.data);
    return response.data;
  },
};
